import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip,capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ApplicationRequestsTableProps {
	applications: any;
	resourceStatuses: any;
}

const ApplicationRequestsTable: React.FC<ApplicationRequestsTableProps> = ({
	applications, resourceStatuses
}: any) => {
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();
		
	return (
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">APPLICATION NAME</Typography>
						</Grid>

						<Grid item textAlign="start" xs={3}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
						<Grid textAlign="start" item xs={3}>
							<Typography fontSize="12px">ACTIONED BY/ REASON</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">ACTIONED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{applications.map((application: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,
						cursor: "pointer",
						bgcolor:
							application.status == "active"
								? "#FFFFFF"
								: application.status == "rejected"
								? "#F0443810"
								: "#FDB02210",
						borderRadius: "8px",
					}}
					onClick={() => {
						navigate(`/requests/applications/details/${application.id}`);
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
				>
					<Box width="100%" sx={{}}>
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													application.status == "active"
														? "#12B76A"
														: application.status == "rejected"
														? "#F04438"
														: "#FDB022",
												bgcolor:
													application.status == "active"
														? "#12B76A"
														: application.status == "rejected"
														? "#F04438"
														: "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{application.applicationName}
										</Typography>{application && application.status === 'active' ? ( 
																				  <Tooltip
																					sx={{ whiteSpace: "pre-line" }}
																					title={
																					  <Box key="applications-tooltip"> 
																						Current Status
																						<br />
																						{resourceStatuses.filter((e:any) => e.resourceId == application.id).map((e: any, index: number) => (
																						  <React.Fragment key={index}>
																							{capitalize(e.currentStatus)}
																							<br />
																						  </React.Fragment>
																						))}
																						
																					  </Box>
																					}
																				  >
																					<Avatar
																					  src="/assets/info.svg"
																					  alt="info"
																					  sx={{ height: 16, width: 16, marginLeft: "4px" }}
																					/>
																				  </Tooltip>
																				) : null}
									</Box>
								}
							</Grid>
							<Grid item xs={3}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={application.applicationOwnerAvatar}
											alt={application.applicationOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{application.applicationOwner}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={2}>
								{
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(application.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={3}>
								{application.status != "pending" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={application.applicationApproverAvatar}
											alt={application.applicationApprover}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>
											{application.applicationApprover}
										</Typography>
										{application.status == "rejected" && (
											<Tooltip title={`Reason: ${application.reasonForRejection}`}>
												<img src="/assets/info.svg" alt="info" />
											</Tooltip>
										)}
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{application.status != "pending" && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(application.actionedAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ApplicationRequestsTable;
